var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIosAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m179.8 65.664h-116.95v9.2604h116.95c5.1065 0 9.2604 4.154 9.2604 9.2604v148.17c0 5.1064-4.154 9.2604-9.2604 9.2604h-148.17c-5.08 0-9.2604-4.154-9.2604-9.2604v-148.17c0-5.08 4.154-9.2604 9.2604-9.2604h37.042v-9.2604h-37.042c-10.239 0-18.521 8.2814-18.521 18.521v148.17c0 10.239 8.2815 18.521 18.521 18.521h148.17c10.239 0 18.521-8.2815 18.521-18.521v-148.17c0-10.239-8.2815-18.521-18.521-18.521z",
    strokeWidth: 0.26458
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.37 100.26v116.67h9.2604v-116.67z",
    strokeWidth: 0.23478
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m163.21 154.23h-116.67v9.2604h116.67z",
    strokeWidth: 0.23478
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosAdd);
export default __webpack_public_path__ + "static/media/ios-add.34dd6e69f357164f1d0dc4c6dc4805ca.svg";
export { ForwardRef as ReactComponent };